import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18px",
  height: "21px",
  viewBox: "0 0 18 21",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Page-1",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "3-3-Produkt:-Zamówienie",
      transform: "translate(-1459, -876)",
      fill: "#F56531",
      "fill-rule": "nonzero"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "ui/delete",
        transform: "translate(1459, 876)"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M8.99930029,0 C10.8234078,-0.000115360438 12.4167194,1.23344123 12.87349,2.99943353 L17,2.99992353 C17.5522847,2.99992353 18,3.44763878 18,3.99992353 C18,4.55220828 17.5522847,4.99992353 17,4.99992353 L11,4.99992353 L11,3.99992353 C11.0016853,3.28441648 10.620965,2.62252926 10.0016263,2.26423777 C9.38228766,1.90594627 8.61871538,1.90585272 7.99928894,2.26399245 C7.37986249,2.62213218 6.99898004,3.28392609 7.00049,3.99943353 L7.001,4.99992353 L3,4.99992353 L3,17.9999235 C3.00071619,18.5519114 3.44801218,18.9992073 4,18.9999235 L14,18.9999235 C14.5519878,18.9992073 14.9992838,18.5519114 15,17.9999235 L15,7.99992353 C15,7.44763878 15.4477153,6.99992353 16,6.99992353 C16.5522847,6.99992353 17,7.44763878 17,7.99992353 L17,17.9999235 C16.9981923,19.6560284 15.6561049,20.9981158 14,20.9999235 L4,20.9999235 C2.34389511,20.9981158 1.00180771,19.6560284 1,17.9999235 L1,4.99992353 C0.44771525,4.99992353 0,4.55220828 0,3.99992353 C0,3.44763878 0.44771525,2.99992353 1,2.99992353 L5.12549,2.99992353 C5.58203723,1.23387347 7.17519279,0.000115360438 8.99930029,0 Z M11.7006254,9.29929813 C12.0886083,9.68728101 12.091453,10.3154426 11.707,10.7069235 L10.414,11.999 L11.707,13.2929235 C11.9929079,13.5789178 12.0784219,14.0089601 11.923678,14.3825781 C11.7689341,14.756196 11.4043959,14.9998372 11,14.9999242 C10.7347342,15.0002241 10.4802902,14.8947756 10.293,14.7069235 L9,13.413 L7.707,14.7069235 C7.51970976,14.8947756 7.26526582,15.0002241 7,14.9999242 C6.5956041,14.9998372 6.23106595,14.756196 6.07632202,14.3825781 C5.92157809,14.0089601 6.00709208,13.5789178 6.293,13.2929235 L7.586,11.999 L6.293,10.7069235 C5.90854701,10.3154426 5.91139172,9.68728101 6.2993746,9.29929813 C6.68735748,8.91131525 7.31551905,8.90847055 7.707,9.29292353 L9,10.585 L10.293,9.29292353 C10.6844809,8.90847055 11.3126425,8.91131525 11.7006254,9.29929813 Z",
          id: "Combined-Shape"
        })
      ])
    ])
  ])
], -1)
const _hoisted_2 = [
  _hoisted_1
]




export default {
  __name: 'DeleteItemButton',
  emits: ['deleteItem'],
  setup(__props, { emit }) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "Button Button--no-style flex items-center justify-center w-[48px] h-[48px] flex-shrink-0 rounded-full bg-accentOrange/10",
    onClick: _cache[0] || (_cache[0] = $event => (emit('deleteItem')))
  }, _hoisted_2))
}
}

}